app.service('rapportService', ['$window', 'crudService', '$q', 'modalService', function ($window, crudService, $q, modalService) {

	/**
	 * Vérifie si le rapport exists et retourne une promise
	 * @param id
	 * @param securityKey
	 * @param typeRapport
	 * @returns {deferred.promise|{then, catch, finally}}
	 */
	this.exists = function(id, securityKey, typeRapport) {
		if(!typeRapport) typeRapport = 'rapport';
		return crudService.get('/'+typeRapport+'/'+id+'/'+securityKey+'/check').then(function(response) {
			if(response) return $q.resolve(response);
			else return $q.reject(response);
		});
	};

	/**
	 * Action pour l'ouverture d'un rapport selon l'id du rapport et la clef de securité
	 * @param id
	 * @param securityKey
	 * @param callback function
	 * @param typeRapport
	 */
	this.open = function(id, securityKey, callback, typeRapport) {

		if(!typeRapport || typeRapport !== 'rapport_audit') typeRapport = 'rapport';

		return this.exists(id, securityKey, typeRapport).then(function() {
			if(callback) callback(this);

			if(typeRapport === 'rapport_audit') $window.location.href = '/rapport_audit/'+id+'/'+securityKey+'/open'; // rapport audit : download car fichier en local
			else window.open('/rapport/'+id+'/'+securityKey+'/open','_blank');	// rapport : ouverture nouvel onglet car fichier à distance
		}, function() {
			modalService.file();
		});
	};



}]);
